var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcYoutubeFooter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93752 6.0166H18.0214C20.196 6.0166 21.9589 7.77949 21.9589 9.95413V15.4949C21.9589 17.6695 20.196 19.4324 18.0214 19.4324H6.93752C4.76289 19.4324 3 17.6695 3 15.4949V9.95413C3 7.77949 4.76289 6.0166 6.93752 6.0166ZM10.1742 15.4667L15.3585 12.9941C15.5144 12.9197 15.5171 12.6987 15.363 12.6206L10.1787 9.99344C10.0402 9.92328 9.87648 10.0239 9.87648 10.1791V15.2788C9.87648 15.4318 10.036 15.5326 10.1742 15.4667Z",
    fill: "#F61C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutubeFooter);
export default __webpack_public_path__ + "static/media/icYoutubeFooter.3ff6fe2aebf3d12105a4e0ff3353e018.svg";
export { ForwardRef as ReactComponent };